import { CompositeDataItem, Voice } from '../store/reducers/sessionReducer'
import apiBase from '../utils/baseApi'

export interface NegotiateParams {
  mentorId: string
  useIdleTimeOut: boolean
  avatarInfo: {
    id: string
    useGreenVideo: boolean
  }
  userContextId?: string
  prevMentorId?: string
  prevSocketId?: string
  linkedInSummary?: string
  profileJson?: string
}

export interface NegotiateResponse {
  connection: {
    signaling_endpoint: string
    id: string
    avatar: {
      voices: Voice[]
    }
  }
  socket_id: string
}

export interface DoNegotiationParams {
  params: NegotiateParams
  abortSignal: AbortSignal
  isAuthenticated: boolean
  trackError: (reason: string) => void
  isInterview?: boolean
}

export async function doNegotiation({
  params,
  abortSignal,
  isAuthenticated,
  trackError,
  isInterview = false,
}: DoNegotiationParams): Promise<NegotiateResponse> {
  try {
    let url = '/v2/sessions/negotiate-signaling'

    if (!isAuthenticated) {
      url = '/v2/sessions/negotiate-signaling-public'
    }

    if (isInterview) {
      url = '/v2/sessions/negotiate-interview'
    }

    const answerResponse = await apiBase.post<NegotiateResponse>(
      url,
      { ...params, useBackChannel: true },
      {
        signal: abortSignal,
      },
    )

    return answerResponse.data
  } catch (error) {
    trackError('negotiate-signaling-api')
    throw error
  }
}
export interface ContextByIdResponse {
  succsess: boolean
  data: {
    userQuery: string
    title: string
    outline: string | null
    clickbaitHeader: string | null
    createdAt: number
    id: string
    imageUrl: string
    prompt: CompositeDataItem[]
    status: string
  }
}

export async function getContextById(id: string): Promise<ContextByIdResponse> {
  const answerResponse = await apiBase.get<ContextByIdResponse>(
    `/v2/contexts/${id}`,
  )

  return answerResponse.data
}

export async function getScreenshot(url: string): Promise<Blob> {
  const response = await apiBase.post<Blob>(
    `/v2/thumbnails`,
    {
      url,
    },
    { responseType: 'blob' },
  )

  return response.data
}
